var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_850_8951)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12.1776C20.8215 12.5321 20.5273 12.6262 20.1438 12.6244C17.6636 12.6131 15.1832 12.6187 12.6885 12.6187C12.6885 12.9872 12.6885 13.3518 12.6885 13.7412C13.0631 13.7412 13.4427 13.7411 13.8222 13.7413C13.9999 13.7414 14.178 13.7338 14.3551 13.7441C14.7023 13.7643 14.9655 14.0452 14.9562 14.3738C14.9467 14.7108 14.6825 14.9722 14.3289 14.9727C11.7802 14.9753 9.23147 14.9752 6.68277 14.973C6.31769 14.9727 6.04701 14.7079 6.04334 14.3656C6.03973 14.0285 6.31277 13.7493 6.67282 13.7436C7.18519 13.7355 7.69774 13.7413 8.21022 13.7412C8.24282 13.7412 8.27531 13.7412 8.31595 13.7412C8.31595 13.3614 8.31595 12.9964 8.31595 12.6187C8.23243 12.6187 8.15859 12.6187 8.08481 12.6187C5.67279 12.6187 3.26066 12.6131 0.848692 12.6245C0.466816 12.6262 0.177428 12.5275 0 12.1776C0 8.26746 0 4.35726 0 0.447103C0.191813 0.0847527 0.505813 0.0229482 0.889713 0.0234404C7.32838 0.0318086 13.7671 0.0317539 20.2058 0.0236045C20.5853 0.0231122 20.8487 0.138791 21 0.488124C21 4.3846 21 8.28108 21 12.1776ZM19.7634 1.27583C13.5774 1.27583 7.40922 1.27583 1.24369 1.27583C1.24369 4.6491 1.24369 8.00881 1.24369 11.3698C7.42344 11.3698 13.5915 11.3698 19.7634 11.3698C19.7634 7.99984 19.7634 4.64456 19.7634 1.27583ZM11.4333 13.7351C11.4333 13.3538 11.4333 12.9942 11.4333 12.6286C10.8071 12.6286 10.1899 12.6286 9.57003 12.6286C9.57003 13.0035 9.57003 13.3683 9.57003 13.7351C10.1951 13.7351 10.808 13.7351 11.4333 13.7351Z",
    fill: "#F82643"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_850_8951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 14.9511,
    fill: "white",
    transform: "translate(0 0.0234375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvTv);
export default __webpack_public_path__ + "static/media/av-tv.745f43f8da6449e8dc0b3a8b9d32007b.svg";
export { ForwardRef as ReactComponent };